import {
  createUnitTypeOptions,
  WORKING_DECLARATION_LABEL_KEYS,
} from '@/config/unitTypes.constants';

// A shipment carries its quantities in the material's working and declaration units.
export const { unitTypeLabel, buildRowUnitOptions, buildUnitHeaderOptions } = createUnitTypeOptions(
  WORKING_DECLARATION_LABEL_KEYS,
);
